// Calculateur de Nidation - Oduho
(function() {
  if (!document.getElementById('calculateBtn')) {
    return; // Pas de calculateur de nidation sur cette page
  }

  console.log('📅 Calculateur de nidation détecté');

  function calculateImplantation() {
    // Récupération des valeurs
    const calcMethod = document.querySelector('input[name="calcMethod"]:checked');

    if (!calcMethod) {
      alert('Veuillez sélectionner une méthode de calcul');
      return;
    }

    const method = calcMethod.value;
    let implantationStart, implantationEnd, testDate, ovulationDate;

    if (method === 'ovulation') {
      const ovulationInput = document.getElementById('ovulationDate').value;
      if (!ovulationInput) {
        alert('Veuillez entrer la date d\'ovulation');
        return;
      }

      ovulationDate = new Date(ovulationInput);

      // Nidation : 6-10 jours après ovulation (moyenne 9 jours)
      implantationStart = new Date(ovulationDate);
      implantationStart.setDate(implantationStart.getDate() + 6);

      implantationEnd = new Date(ovulationDate);
      implantationEnd.setDate(implantationEnd.getDate() + 10);

      // Test fiable : 10-14 jours après nidation (soit 16-24 jours après ovulation)
      testDate = new Date(ovulationDate);
      testDate.setDate(testDate.getDate() + 20); // Moyenne recommandée

    } else if (method === 'lastPeriod') {
      const periodInput = document.getElementById('lastPeriodDate').value;
      const cycleLength = parseInt(document.getElementById('cycleLength').value);

      if (!periodInput || !cycleLength) {
        alert('Veuillez remplir tous les champs');
        return;
      }

      const periodDate = new Date(periodInput);

      // Ovulation estimée : cycle - 14 jours
      ovulationDate = new Date(periodDate);
      ovulationDate.setDate(ovulationDate.getDate() + (cycleLength - 14));

      // Nidation : 6-10 jours après ovulation estimée
      implantationStart = new Date(ovulationDate);
      implantationStart.setDate(implantationStart.getDate() + 6);

      implantationEnd = new Date(ovulationDate);
      implantationEnd.setDate(implantationEnd.getDate() + 10);

      // Test fiable
      testDate = new Date(ovulationDate);
      testDate.setDate(testDate.getDate() + 20);
    }

    // Format des dates en français
    const options = { day: 'numeric', month: 'long', year: 'numeric' };

    // Construction du résultat
    let resultHTML = `
      <div style="background: linear-gradient(135deg, #e8f5e8 0%, #d4ebd4 100%); padding: 25px; border-radius: 12px; margin-top: 20px; border-left: 5px solid #7db87d;">
        <h3 style="color: #5d7a5d; margin-top: 0; font-size: 1.3em; font-weight: 600;">📅 Vos Dates Calculées</h3>

        <div style="background: white; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
          <p style="margin: 0 0 5px 0; font-weight: 600; color: #6b4e5c;">Ovulation estimée</p>
          <p style="margin: 0; font-size: 1.1em; color: #4a4a4a;">${ovulationDate.toLocaleDateString('fr-FR', options)}</p>
        </div>

        <div style="background: white; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
          <p style="margin: 0 0 5px 0; font-weight: 600; color: #6b4e5c;">Fenêtre de nidation probable</p>
          <p style="margin: 0; font-size: 1.1em; color: #4a4a4a;">Du ${implantationStart.toLocaleDateString('fr-FR', options)}<br>au ${implantationEnd.toLocaleDateString('fr-FR', options)}</p>
          <p style="margin: 10px 0 0 0; font-size: 0.9em; color: #7a7a7a; font-style: italic;">Soit 6 à 10 jours après l'ovulation</p>
        </div>

        <div style="background: white; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
          <p style="margin: 0 0 5px 0; font-weight: 600; color: #6b4e5c;">Date recommandée pour le test</p>
          <p style="margin: 0; font-size: 1.1em; color: #4a4a4a;">${testDate.toLocaleDateString('fr-FR', options)}</p>
          <p style="margin: 10px 0 0 0; font-size: 0.9em; color: #7a7a7a; font-style: italic;">Soit environ 20 jours après l'ovulation</p>
        </div>

        <div style="background: linear-gradient(135deg, #fff8f0 0%, #fef5eb 100%); padding: 15px; border-radius: 8px; border-left: 3px solid #e8a05d;">
          <p style="margin: 0; line-height: 1.6; color: #4a4a4a; font-size: 0.95em;">
            <strong style="color: #b87a40;">⚠️ Important :</strong> Ces dates sont des estimations. La nidation peut varier de plusieurs jours selon votre corps. Si vous testez avant la date recommandée et que c'est négatif, retestez quelques jours plus tard.
          </p>
        </div>
      </div>
    `;

    // Ajout d'une timeline visuelle
    const today = new Date();
    const daysUntilTest = Math.ceil((testDate - today) / (1000 * 60 * 60 * 24));

    if (daysUntilTest > 0) {
      resultHTML += `
        <div style="background: #fff9f9; padding: 20px; border-radius: 8px; margin-top: 15px; border-left: 3px solid #d97575;">
          <p style="margin: 0; font-weight: 600; color: #b85f5f;">🕐 Patience requise</p>
          <p style="margin: 5px 0 0 0; color: #4a4a4a;">Il vous reste <strong>${daysUntilTest} jour${daysUntilTest > 1 ? 's' : ''}</strong> d'attente avant de pouvoir tester de façon fiable. Tester trop tôt risque de donner un faux négatif.</p>
        </div>
      `;
    } else if (daysUntilTest < 0 && daysUntilTest > -7) {
      resultHTML += `
        <div style="background: linear-gradient(135deg, #e8f5e8 0%, #d4ebd4 100%); padding: 20px; border-radius: 8px; margin-top: 15px; border-left: 3px solid #7db87d;">
          <p style="margin: 0; font-weight: 600; color: #5d7a5d;">✅ C'est le moment !</p>
          <p style="margin: 5px 0 0 0; color: #4a4a4a;">Vous êtes dans la fenêtre optimale pour faire un test de grossesse fiable. Utilisez votre première urine du matin pour de meilleurs résultats.</p>
        </div>
      `;
    }

    document.getElementById('calculationResult').innerHTML = resultHTML;
    document.getElementById('calculationResult').style.display = 'block';
    document.getElementById('calculationResult').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function toggleFields() {
    const method = document.querySelector('input[name="calcMethod"]:checked');
    if (!method) return;

    const ovulationFields = document.getElementById('ovulationFields');
    const periodFields = document.getElementById('periodFields');

    if (method.value === 'ovulation') {
      ovulationFields.style.display = 'block';
      periodFields.style.display = 'none';
    } else {
      ovulationFields.style.display = 'none';
      periodFields.style.display = 'block';
    }
  }

  // ========== ATTACHER LES ÉVÉNEMENTS ==========
  // Bouton "Calculer Ma Nidation" — c'était le maillon manquant du script d'origine :
  // la fonction calculateImplantation() existait mais n'était jamais appelée au clic
  const calculateBtn = document.getElementById('calculateBtn');
  calculateBtn.addEventListener('click', function(e) {
    e.preventDefault();
    calculateImplantation();
  });

  const radios = document.querySelectorAll('input[name="calcMethod"]');
  radios.forEach(function(radio) {
    radio.addEventListener('change', toggleFields);
  });

  // Initialisation de l'affichage
  toggleFields();

  console.log('✅ Calculateur de nidation initialisé');
})();